export const ADD_NEW_NON_SALEABLE_RETURN = "ADD_NEW_NON_SALEABLE_RETURN";
export const ADD_NEW_NON_SALEABLE_RETURN_SUCCESS = "ADD_NEW_NON_SALEABLE_RETURN_SUCCESS";
export const EDIT_NON_SALEABLE_RETURN = "EDIT_NON_SALEABLE_RETURN";
export const EDIT_NON_SALEABLE_RETURN_SUCCESS = "EDIT_NON_SALEABLE_RETURN_SUCCESS";
export const DELETE_NON_SALEABLE_RETURN = "DELETE_NON_SALEABLE_RETURN";
export const DELETE_NON_SALEABLE_RETURN_SUCCESS = "DELETE_NON_SALEABLE_RETURN_SUCCESS";